import { ReactElement } from 'react';

export const createUploadMethod = <TProps extends Record<string, any>>(
    component: (props: TProps) => ReactElement | null,
    props: DefaultUploadMethodProps & TProps
): Method<TProps> => ({
    component: component,
    props: props
});

type Method<TProps> = {
    component: (props: TProps) => ReactElement | null;
    props: DefaultUploadMethodProps & TProps;
};

type DefaultUploadMethodProps = {

    maxSize: number;
    accept: string;
    closeOnUpload: boolean;
    multiple: boolean;

    onOpen?: () => void;
    onChange: (...args: any[]) => void;
};

// Typing from: https://stackoverflow.com/questions/52963637/typescript-is-it-possible-to-get-the-return-type-of-a-generic-function
// This is done for the same reason as store.ts
const createDefaultType = () => createUploadMethod<any>((any: any) => null, {});

export type UploadMethodsProps = {
    Dropzone: ReturnType<typeof createDefaultType>;
    ExternalUpload?: ReturnType<typeof createDefaultType>;
};